import type { VehicleDriverLink } from '@/types/vehicle'

function isRecord(value: unknown): value is Record<string, unknown> {
  return value != null && typeof value === 'object' && !Array.isArray(value)
}

function hasDriverIdentity(row: Record<string, unknown>): boolean {
  const id = row.id ?? row.driver_id
  if (id == null || id === '') return false
  if (typeof id === 'number' && !Number.isFinite(id)) return false
  if (typeof id === 'string' && !id.trim()) return false
  return true
}

/** Unwrap driver link from varied API envelopes; null when unassigned or empty. */
export function parseVehicleDriverLink(payload: unknown): VehicleDriverLink | null {
  if (!isRecord(payload)) return null

  let candidate: unknown = payload

  if (isRecord(payload.data)) {
    const inner = payload.data
    if ('driver' in inner) {
      candidate = inner.driver
    } else if (hasDriverIdentity(inner)) {
      candidate = inner
    }
  } else if ('driver' in payload) {
    candidate = payload.driver
  }

  if (!isRecord(candidate) || !hasDriverIdentity(candidate)) return null

  return candidate as VehicleDriverLink
}
